import React, { Component } from 'react'
import Locale from '../data/localization'

export default class Legend extends Component {

    constructor(props) {
        super(props)

        this.state = {
            active: false
        }
    }

    handleClick(event) {
        event.preventDefault()

        this.setState({
            active: !this.state.active
        })
    }

    render() {

        return (
            <div className={`Legend ${this.state.active ? 'is-active' : ''}`}>
                <button type="button" className="Legend-toggle" onClick={::this.handleClick}>?</button>
                <div className="Legend-content">
                    <div className="Legend-item Legend-item--escalator">{Locale.map.legend.escalator}</div>
                    <div className="Legend-item Legend-item--stairs">{Locale.map.legend.stairs}</div>
                    <div className="Legend-item Legend-item--elevator">{Locale.map.legend.elevator}</div>
                    <div className="Legend-item Legend-item--toilets">{Locale.map.legend.toilets}</div>
                    <div className="Legend-item Legend-item--handicap">{Locale.map.legend.handicap}</div>
                    <div className="Legend-item Legend-item--baby">{Locale.map.legend.baby}</div>
                    <div className="Legend-item Legend-item--babyBottle">{Locale.map.legend.babyBottle}</div>
                    <div className="Legend-item Legend-item--info">{Locale.map.legend.info}</div>
                </div>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./components/Legend.js